import { useDispatch } from 'react-redux';
import { useState } from 'react';
import { CommanderThunkDispatch } from '@mews-commander/types';
import { useCommanderSelector } from '@mews-commander/utils';
import { canSendMessage, currentThreadDraft } from '../selectors';
import { getCurrentThreadId } from '../selectors/threads';
import { SendMessageComponent } from '../components/SendMessageComponent';
import { messageDraftUpdated } from '../actions/messages';

export interface SendMessageProps {
    onSend: () => void;
}

export const SendMessage = ({ onSend }: SendMessageProps) => {
    const dispatch: CommanderThunkDispatch = useDispatch();
    const [isMessageValid, setIsMessageValid] = useState(true);
    const draftText = useCommanderSelector(currentThreadDraft);
    const currentThreadId = useCommanderSelector(getCurrentThreadId);
    const sendMessage = useCommanderSelector((state) => canSendMessage(state, currentThreadId));

    const onTextChanged = (threadId: string, text: string) => {
        if (draftText === text) {
            return;
        }
        dispatch(messageDraftUpdated(threadId, text));
        const validateMessage = !text.includes('[') && !text.includes(']');
        setIsMessageValid(validateMessage);
    };

    return (
        <SendMessageComponent
            canSendMessage={sendMessage && isMessageValid}
            onSend={onSend}
            text={draftText}
            threadId={currentThreadId}
            onTextChanged={onTextChanged}
        />
    );
};
